import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "help-index"
  }, [_c('tip'), _c('search-box', {
    attrs: {
      "showHotKeywords": ""
    },
    on: {
      "search": _vm.handleSearch
    }
  }), _c('div', {
    staticClass: "pt-35 pb-60 bf main-rule"
  }, [_c('h1', {
    staticClass: "tc pb-15 help-center-title"
  }, [_c('div', [_vm._v(_vm._s(_vm.t('主要规则')))])]), _c('div', {
    staticClass: "main-rule-wrap"
  }, [_vm.mainContent.main_rule ? _c('my-carousel', {
    attrs: {
      "isPage": true,
      "contentWidth": 1183,
      "pointerBackgroud": "#F2804F",
      "margin": 20
    }
  }, [_c('div', {
    staticStyle: {
      "width": "36px"
    },
    attrs: {
      "slot": "icon-left"
    },
    slot: "icon-left"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/helpCenter/left.svg")
    }
  })]), _c('div', {
    staticStyle: {
      "width": "36px"
    },
    attrs: {
      "slot": "icon-right"
    },
    slot: "icon-right"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/helpCenter/right.svg")
    }
  })]), _vm._l(_vm.mainContent.main_rule, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "main-rule-wrap__rule-item",
      on: {
        "click": function ($event) {
          return _vm.handleJumpLink(item.url);
        }
      }
    }, [_c('div', [_c('div', {
      staticClass: "main-rule-wrap__rule-icon"
    }, [_c('img', {
      attrs: {
        "src": _vm.rfsViewUrl + "?path=" + item.icon_url
      }
    })]), _c('div', {
      staticClass: "main-rule-wrap__text-cont"
    }, [_c('p', {
      staticClass: "p1"
    }, [_vm._v(_vm._s(item.title))]), _c('p', {
      staticClass: "p2"
    }, [_vm._v(_vm._s(item.desc))])])])]);
  })], 2) : _vm._e(), _vm.isPending ? _c('a-skeleton', {
    attrs: {
      "active": ""
    }
  }) : _vm._e()], 1)]), _c('div', {
    staticClass: "pt-35 pb-100 begin-guide"
  }, [_c('h1', {
    staticClass: "tc pb-15 help-center-title"
  }, [_c('div', [_vm._v(_vm._s(_vm.t('新手入门')))])]), _c('div', {
    staticClass: "begin-guide-wrap"
  }, [_vm.mainContent.guide ? _c('my-carousel', {
    attrs: {
      "multiples": 1.1,
      "transforMation": _vm.transforMation,
      "contentWidth": 1183,
      "showCount": _vm.showCount,
      "infinite": false,
      "margin": 40
    }
  }, [_c('div', {
    staticStyle: {
      "width": "36px"
    },
    attrs: {
      "slot": "icon-left"
    },
    slot: "icon-left"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/helpCenter/left.svg")
    }
  })]), _c('div', {
    staticStyle: {
      "width": "36px"
    },
    attrs: {
      "slot": "icon-right"
    },
    slot: "icon-right"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/helpCenter/right.svg")
    }
  })]), _vm._l(_vm.mainContent.guide, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "begin-guide-wrap__rule-item"
    }, [_c('div', [_c('a', {
      attrs: {
        "href": item.url,
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "serial-number"
    }, [_vm._v(" " + _vm._s(index + 1 >= 10 ? index + 1 : '0' + (index + 1)))]), _c('p', {
      staticClass: "p1"
    }, [_vm._v(_vm._s(item.title))]), _c('p', {
      staticClass: "p2"
    }, [_vm._v(_vm._s(item.desc))])])])]);
  })], 2) : _vm._e(), _vm.isPending ? _c('a-skeleton', {
    attrs: {
      "active": ""
    }
  }) : _vm._e()], 1)]), !_vm.isPending ? _c('div', {
    staticClass: "pt-35 pb-100 bf faq-cont"
  }, [_c('h1', {
    staticClass: "tc pb-15 help-center-title"
  }, [_c('div', [_vm._v(" " + _vm._s(_vm.t('常见问题')) + " ")])]), _c('div', [_c('div', {
    staticClass: "faq-cont-wrap"
  }, [_vm._l(_vm.mainContent.faq.slice(0, 8), function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "faq-cont-wrap__rule-item"
    }, [_c('div', {
      staticClass: "mb-10 bd faq-cont-wrap__rule-item-title"
    }, [_vm._v(_vm._s(item.block_title))]), _c('div', {
      staticClass: "faq-cont-wrap__rule-item-items"
    }, _vm._l(item.block_items.slice(0, 4), function (block) {
      return _c('p', {
        key: block.title
      }, [_c('a', {
        attrs: {
          "href": block.url,
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(block.title))])]);
    }), 0)]);
  }), _vm.isPending ? _c('a-skeleton', {
    attrs: {
      "active": ""
    }
  }) : _vm._e()], 2), _vm.mainContent.faq.length ? _c('span', {
    staticClass: "faq-cont-more",
    attrs: {
      "data-permission": "help_index_faq",
      "id": "help_index_faq"
    },
    on: {
      "click": function ($event) {
        return _vm.$router.push('/help/faq/list');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.t('更多')) + ">> ")]) : _vm._e()])]) : _vm._e()], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };